module.exports = __webpack_public_path__ + "static/img/050.39ce7da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/050.png
// module id = ofWP
// module chunks = 0